// service-config-lint-disable: runtime-enriched-config-export-flow-covered -- this service is intentionally enriched at runtime, and the export flow already handles it as well.
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { IPagesDefinition } from '@wix/viewer-service-pages/definition'
import { PagesDefinition as definition } from '@wix/viewer-service-pages/definition'
import { PagesService as impl } from '@wix/viewer-service-pages/implementations'
import { name } from './symbols'
import type { PagesServicePageConfig, PagesServiceSiteConfig } from './types'

export const sitePagesService: FactoryWithDependencies<ServiceProvider<IPagesDefinition, typeof impl>> =
	withDependencies(
		[named(SiteFeatureConfigSymbol, name)] as const,
		(siteConfig: PagesServiceSiteConfig): ServiceProvider<IPagesDefinition, typeof impl> => ({
			definition,
			impl,
			config: siteConfig,
			platformConfig: siteConfig,
		})
	)

export const pagesService: FactoryWithDependencies<ServiceProvider<IPagesDefinition, typeof impl>> = withDependencies(
	[named(PageFeatureConfigSymbol, name), named(SiteFeatureConfigSymbol, name)] as const,
	(
		pageFeatureConfig: PagesServicePageConfig,
		siteConfig: PagesServiceSiteConfig
	): ServiceProvider<IPagesDefinition, typeof impl> => {
		const config = {
			...pageFeatureConfig,
			mainPageId: siteConfig.mainPageId,
		}
		return {
			definition,
			impl,
			config,
			platformConfig: config,
		}
	}
)
